import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Button, Stack} from '@travel-frontend/ui-components';

import {Divider} from '@/components/Divider';

type Props = {
  mapView?: boolean;
};

export const Container = styled(Stack)<Props>(
  ({theme, mapView}) => css`
    background-color: ${theme.colors.backgroundPrimary};
    gap: 0;
    border: 1px solid ${theme.colors.borderSecondary};
    border-radius: 5px;
    z-index: 1;

    ${Button} {
      width: 100%;
      padding: 8px 0;

      &:hover {
        background-color: ${theme.colors.backgroundStateHover};
      }
    }

    ${mapView && theme.elevations.large};

    ${Divider} {
      margin: 8px 0;
    }

    ${Stack} {
      text-align: left;
    }
  `
);
